import Card, {CARD_EMPHASIS} from "../../util/card/Card";
import {setDateFilter} from "../../../ducks/assets-duck";
import DirectionIcon from "../../util/icons/DirectionIcon";
import {numberFormat} from "../../../util/numbers";
import {useAssets} from "./use-assets";
import CloseIcon from "mdi-react/CloseIcon";
import dayjs from "dayjs";
import './DateFilter.scss';
import {useDispatch} from "react-redux";
import CalendarBlankIcon from "mdi-react/CalendarSearchIcon";

export default () => {

    const dispatch = useDispatch()

    const {
        assetsOrdered,
        dateFilter,
    } = useAssets()

    const secondsSinceFilterDate = dayjs().diff(dayjs(dateFilter))
    const daysSinceFilterDate = Math.floor(secondsSinceFilterDate / (60 * 60 * 24 * 1000))
    const gainChange = assetsOrdered.reduce((acc, cur) => acc + (cur.value - (cur.value / (1 + cur.changePct))), 0)

    return dateFilter && (
        <div className='date-filter'>
            <Card
                onClick={() => dispatch(setDateFilter())}
                emphasis={CARD_EMPHASIS.SECONDARY}
            >
                <div className='flex-vertical-center'>
                    <CalendarBlankIcon className='date-filter-icon' />
                    <div className='weekday'>
                        {dayjs(dateFilter).format("ddd")?.toLowerCase()}
                    </div>
                    <div className='date'>
                        {dateFilter}
                    </div>
                    <div className='days-since'>
                        {daysSinceFilterDate}
                    </div>
                    <div className='desc'>
                        retrospective
                    </div>
                    {gainChange === 0 ?
                        <div className='no-change'>
                            no change
                        </div>
                        :
                        <>
                            <div className='direction'>
                                <DirectionIcon value={gainChange}/>
                            </div>
                            <div className={`change`}>
                                {numberFormat(Math.abs(gainChange))}
                            </div>
                        </>
                    }
                    <div className='close-icon'>
                        <CloseIcon/>
                    </div>
                </div>
            </Card>
        </div>
    )
}